import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    userType: string;
    userInfo: any;
    userType$ = new BehaviorSubject('');
    dfosRole: any;
    constructor(private location: Location) { }

    setLoginUserType(type: string) {
        this.userType = type;
        this.userType$.next(type);
    }
    setDFOSRole(role) {
        this.dfosRole = role;
    }

    getLoginUserType() {
        return this.userType;
    }

    setUserInfo(userInfo: any) {
        this.userInfo = userInfo;
    }

    getUserInfo() {
        return this.userInfo;
    }

    isAuthenticated() {
        if (this.getUserInfo()) {
            return true;
        } else {
            return false;
        }
    }

    goBack() {
        this.location.back();
    }

    // Set Token expiry time in local storage
    setTokenExpiryTime(payload) {
        if (payload && payload.expiresOn) {
            const tokenExpiryTime = moment(payload.expiresOn).format('YYYY-MM-DD HH:mm:ss');
            localStorage.setItem('token_expiry_time', tokenExpiryTime);
        }
    }

    // Get token expiry time
    getTokenExpiryTime() {
        const expiry = localStorage.getItem('token_expiry_time');
        return expiry;
    }

    // Remove token expiry time
    removeTokenExpiryTime() {
        localStorage.removeItem('token_expiry_time');
    }

    // Set AD Token in local storage
    setADToken(rawIdToken) {
        localStorage.setItem('ad_token', rawIdToken);
    }

    // Get token expiry time
    getADToken() {
        return localStorage.getItem('ad_token');
    }

    // Remove token expiry time
    removeADToken() {
        localStorage.removeItem('ad_token');
    }
}
